"use strict";
'use es6';
/**
 * Converts an Iterable to a native JS structure.
 *
 * @param  {Iterable} subject to convert.
 * @return {Array|Object} native JS requivalent of `subject`.
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toJS;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function toJS(subject) {
  if ((0, _typeof2.default)(subject) !== 'object' || !subject) {
    return subject;
  }

  if (typeof subject.toJS === 'function') {
    return subject.toJS();
  }

  if (typeof subject.toJSON === 'function') {
    return subject.toJSON();
  }

  return subject;
}

module.exports = exports.default;